import urlCatalog from '@angi/url-catalog';
import React from 'react';
import { Track } from 'angieslist-app-platform';
import './HelpFooter.scss';

const HelpFooter = () => (
  <div className="businesslist-help-container">
    <div className="help-title">Not seeing the business you’re trying to manage?</div>
    <div className="help-description-container">
      <div className="help-description"> Learn how to manage all of your businesses with one email
        <Track>
          <a
            href="https://intercom.help/angi/en/articles/11066470-use-a-single-sign-in-to-manage-multiple-businesses"
            id="intercom-link"
            target="_blank"
            rel="noopener noreferrer"
          ><strong> here.</strong>
          </a>
        </Track>
      </div>
      <div className="help-description">Or, call us at
        <Track>
          <a href={urlCatalog.global.customerCarePhone()} id="phone"><strong> {urlCatalog.global.customerCarePhoneText()}. </strong></a>
        </Track>
        Monday-Friday 8AM-8PM ET and Saturday 9AM-3PM ET.
      </div>
    </div>
  </div>
);

export default HelpFooter;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/HelpFooter.js